import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { created } from "@syncfusion/ej2-react-richtexteditor";
import toast from "react-hot-toast";
import { privateRequest } from "services/privateRequest";
import { getProjectId } from "utils/utils";
import { ReactComponent as CalenderIcon } from "../../assets/Icons/Calender.svg";
import { ReactComponent as CheckIcon } from "../../assets/Icons/check.svg";
import { ReactComponent as NoteIcon } from "../../assets/Icons/Notepad.svg";
import { ReactComponent as EditPenIcon } from "../../assets/Icons/EditPen.svg";
import dayjs from "dayjs";
import { dashboardStatusLabels } from "utils/constants";
const initialState = {
  boxViewDetails: [],
  issueCountDetails: {},
  issueProgressCount: {},
  issuePriorityCount: {},
  issueWorkloadDetails: {},
  issueWorkloadOverview: {},
  issueTimeLog: {},
  overdueIssues: [],
  upcomingIssues: [],
  requestTypeData: [],
  resolvedRequestData: [],
  slaMetricsData: {},
  burnDownData: {},
  boxViewLoading: false,
  issueCountLoading: false,
  issuePriorityLoading: false,
  issueWorkloadLoading: false,
  issueWorkloadOverviewLoading: false,
  issueTimeLogLoading: false,
  overdueIssuesLoading: false,
  upcomingIssuesLoading: false,
  requestTypeLoading: false,
  resolvedRequestLoading: false,
  slaMetricsLoading: false,
  issueTypeCountLoading: false,
  burnDownLoading: false,
  error: null,
};
const iconsArray = [
  <CheckIcon height={"20px"} width={"20px"} />,
  <NoteIcon height={"20px"} width={"20px"} />,
  <CalenderIcon height={"20px"} width={"20px"} />,
  <EditPenIcon height={"20px"} width={"20px"} />,
];

function convertObjectToArray(obj) {
  return Object.keys(obj).map((key, i) => ({
    label: dashboardStatusLabels[key],
    value: obj[key],
    icon: iconsArray[i] || iconsArray[0],
  }));
}
export const fetchBoxViewDetails = createAsyncThunk(
  "dashboard/fetchBoxViewDetails",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/issue-count`,
        { params: { projectId: getProjectId(), ...params } }
      );
      const data = res?.data?.data;
      const newDetails = convertObjectToArray(data);
      return newDetails;
    } catch (error) {
      toast.error("Something went wrong");
      return [];
    }
  }
);

export const fetchIssueCountDetails = createAsyncThunk(
  "dashboard/fetchIssueCountDetails",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/${getProjectId()}/issue-assignments`,
        { params }
      );
      const data = res?.data?.data;
      const backgroundColors = data.map((_, index) => {
        return `hsl(${index * 40}, 70%, 50%)`;
      });
      const idata = {
        labels: data.map((item) => item.assignee),
        datasets: [
          {
            data: data.map((item) => item.issueCount),
            backgroundColor: backgroundColors,
            borderWidth: 1,
          },
        ],
      };

      const backgroundColors2 = data.map((_, index) => {
        return `hsl(${(index + 10) * 80}, 70%, 50%)`;
      });

      const chartData = {
        labels: data.map((item) => item?.assignee) || [],
        datasets: [
          {
            label: "Issue count",
            data: data.map((item) => item?.inProgressIssueCount) || [],
            backgroundColor: backgroundColors2,
            borderWidth: 1,
          },
        ],
      };
      return { idata, chartData };
    } catch (error) {
      toast.error("Something went wrong");
      return {
        idata: { labels: [], datasets: [] },
        chartData: { labels: [], datasets: [] },
      };
    }
  }
);

export const fetchIssuePriorityCountDetails = createAsyncThunk(
  "dashboard/fetchIssuePriorityCountDetails",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/${getProjectId()}/issue-priority`,
        { params }
      );

      const data = res?.data?.data || [];
      const backgroundColors = data.map((_, index) => {
        return `hsl(${index * 60}, 70%, 50%)`;
      });

      const chartData = {
        labels: ["Highest", "High", "Low", "Lowest"],
        datasets: [
          {
            label: "Priority Count",
            data: [
              data.find((item) => item.priority === "HIGHEST")?.count || 0,
              data.find((item) => item.priority === "HIGH")?.count || 0,
              data.find((item) => item.priority === "LOW")?.count || 0,
              data.find((item) => item.priority === "LOWEST")?.count || 0,
            ],
            backgroundColor: [
              "#ef4444",
              "#f97316",
              "#3b82f6",
              "#6366f1",
            ],
            borderWidth: 1,
          },
        ],
      };

      return chartData;
    } catch (error) {
      toast.error("Something went wrong");

      return {
        labels: [],
        datasets: [],
      };
    }
  }
);

export const fetchIssueWorkloadDetails = createAsyncThunk(
  "dashboard/fetchIssueWorkloadDetails",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/${getProjectId()}/workload-overview`,
        { params }
      );
      const data = res?.data?.data;

      const backgroundColors = data.map((_, index) => {
        return `hsl(${index * 40}, 70%, 50%)`;
      });

      const chartData = {
        labels: data.map((item) => item?.stageName) || [],
        datasets: [
          {
            data: data.map((item) => item?.issueCount) || [],
            backgroundColor: backgroundColors,
            borderWidth: 1,
          },
        ],
      };

      return chartData;
    } catch (error) {
      toast.error("Something went wrong");
      return { labels: [], datasets: [] };
    }
  }
);

export const fetchIssueWorkloadOverview = createAsyncThunk(
  "dashboard/fetchIssueWorkloadOverview",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/${getProjectId()}/team-workload`,
        { params }
      );
      const data = res?.data?.data;

      const sortedData = data.sort((a, b) => b.percentage - a.percentage);

      const chartData = {
        labels:
          sortedData.map((item) => item?.assignee.trim() || "Unassigned") || [],
        datasets: [
          {
            label: "",
            data: sortedData.map((item) => item?.percentage) || [],
            backgroundColor: "lightgrey",
          },
        ],
      };

      return chartData;
    } catch (error) {
      toast.error("Something went wrong");
      return { labels: [], datasets: [] };
    }
  }
);

export const fetchIssueTimeLog = createAsyncThunk(
  "dashboard/fetchIssueTimeLog",
  async (params) => {
    try {
      const date = new Date();
      const lastWeekDate = dayjs(date).subtract(7, "day");
      const startDate = dayjs(params?.startDate || lastWeekDate).format("YYYY-MM-DD");
      const endDate = dayjs(params?.endDate || date).format("YYYY-MM-DD");
      const res = await privateRequest.get(
        `api/dashboard/issues/time-log`
        , {
          params: {
            "start-date": startDate,
            "end-date": endDate,
            projectId: getProjectId()
          }
        });
      const data = res?.data?.data;
      const labels = Array.isArray(data)
        ? data.map((item) => item?.userName?.trim() || "Unassigned")
        : [];

      const datasetData = Array.isArray(data)
        ? data.map((item) => item?.totalSpentTime / 3600)
        : [];
      const chartData = {
        labels,
        datasets: [
          {
            label: "Time",
            data: datasetData,
            backgroundColor: "lightblue",
          },
        ],
      };

      return chartData;
    } catch (error) {
      toast.error("Something went wrong");
      return { labels: [], datasets: [] };
    }
  }
);

export const fetchOverdueIssue = createAsyncThunk(
  "dashboard/fetchOverdueIssue",
  async (params) => {
    try {
      let url = `api/dashboard/due-issues?projectId=${getProjectId()}&type=overdue`;
      const response = await privateRequest.get(url, { params });
      const overdue = response?.data?.data?.data || [];
      const totalData = response?.data?.data?.count?.total;
      // console.log('response', response.data.data.count.total)
      return { total: totalData, data: overdue };
    } catch (error) {
      toast.error("Something went wrong");
      return [];
    }
  }
);

export const fetchUpcomingOverdueIssue = createAsyncThunk(
  "dashboard/fetchUpcomingOverdueIssue",
  async (params) => {
    try {
      let url = `api/dashboard/due-issues?projectId=${getProjectId()}&type=upcoming-overdue`;

      const response = await privateRequest.get(url, { params });
      const upcomingIssues = response?.data?.data?.data;
      const totalData = response?.data?.data?.count?.total;
      // console.log('response', response.data.data.count.total)
      return { total: totalData, data: upcomingIssues };
    } catch (error) {
      toast.error("Something went wrong");
      return [];
    }
  }
);

export const fetchRequestTypeData = createAsyncThunk(
  "dashboard/fetchRequestTypeData",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/${getProjectId()}/request-type`, { params }
      );
      return res?.data?.data || [];
    } catch (error) {
      toast.error("Something went wrong");
      return [];
    }
  }
);

export const fetchResolvedRequest = createAsyncThunk(
  "dashboard/fetchResolvedRequest",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/${getProjectId()}/resolved-requests`, { params });
      return res?.data?.data || [];
    } catch (error) {
      toast.error("Something went wrong");
      return [];
    }
  }
);

export const fetchSlaMetrics = createAsyncThunk(
  "dashboard/fetchSlaMetrics",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/${getProjectId()}/sla-metrics`, { params });
      return res?.data?.data || {};
    } catch (error) {
      toast.error("Something went wrong");
      return {};
    }
  }
);

export const fetchIssueTypeCount = createAsyncThunk(
  "dashboard/fetchIssueTypeCount",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/issues/type-count`, { params });
      return res?.data?.data || [];
    } catch (error) {
      toast.error("Something went wrong");
      return [];
    }
  }
);

export const fetchBurnDown = createAsyncThunk(
  "dashboard/fetchBurnDown",
  async (params) => {
    try {
      const res = await privateRequest.get(
        `api/dashboard/projects/${getProjectId()}/burndown`, { params });
      return res?.data?.data || {};
    } catch (error) {
      toast.error("Something went wrong");
      return {};
    }
  }
);

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBoxViewDetails.pending, (state) => {
        state.boxViewLoading = true;
      })
      .addCase(fetchBoxViewDetails.fulfilled, (state, action) => {
        state.boxViewLoading = false;
        state.boxViewDetails = action.payload;
      })
      .addCase(fetchBoxViewDetails.rejected, (state, action) => {
        state.boxViewLoading = false;
        state.boxViewDetails = convertObjectToArray({
          created: 1,
          updated: 18,
          completed: 9,
          dueSoon: 0,
        });
        state.error = action.error.message;
      })
      .addCase(fetchIssueCountDetails.pending, (state) => {
        state.issueCountLoading = true;
      })
      .addCase(fetchIssueCountDetails.fulfilled, (state, action) => {
        state.issueCountLoading = false;
        state.issueCountDetails = action.payload.idata;
        state.issueProgressCount = action.payload.chartData;
      })
      .addCase(fetchIssueCountDetails.rejected, (state, action) => {
        state.issueCountLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchIssuePriorityCountDetails.pending, (state) => {
        state.issuePriorityLoading = true;
      })
      .addCase(fetchIssuePriorityCountDetails.fulfilled, (state, action) => {
        state.issuePriorityLoading = false;
        state.issuePriorityCount = action.payload;
      })
      .addCase(fetchIssuePriorityCountDetails.rejected, (state, action) => {
        state.issuePriorityLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchIssueWorkloadDetails.pending, (state) => {
        state.issueWorkloadLoading = true;
      })
      .addCase(fetchIssueWorkloadDetails.fulfilled, (state, action) => {
        state.issueWorkloadLoading = false;
        state.issueWorkloadDetails = action.payload;
      })
      .addCase(fetchIssueWorkloadDetails.rejected, (state, action) => {
        state.issueWorkloadLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchIssueWorkloadOverview.pending, (state) => {
        state.issueWorkloadOverviewLoading = true;
      })
      .addCase(fetchIssueWorkloadOverview.fulfilled, (state, action) => {
        state.issueWorkloadOverviewLoading = false;
        state.issueWorkloadOverview = action.payload;
      })
      .addCase(fetchIssueWorkloadOverview.rejected, (state, action) => {
        state.issueWorkloadOverviewLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchIssueTimeLog.pending, (state) => {
        state.issueTimeLogLoading = true;
      })
      .addCase(fetchIssueTimeLog.fulfilled, (state, action) => {
        state.issueTimeLogLoading = false;
        state.issueTimeLog = action.payload;
      })
      .addCase(fetchIssueTimeLog.rejected, (state, action) => {
        state.issueTimeLogLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchOverdueIssue.pending, (state) => {
        state.overdueIssuesLoading = true;
      })
      .addCase(fetchOverdueIssue.fulfilled, (state, action) => {
        state.overdueIssuesLoading = false;
        state.overdueIssues = action.payload || [];
      })
      .addCase(fetchOverdueIssue.rejected, (state, action) => {
        state.overdueIssuesLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchUpcomingOverdueIssue.pending, (state) => {
        state.upcomingIssuesLoading = true;
      })
      .addCase(fetchUpcomingOverdueIssue.fulfilled, (state, action) => {
        state.upcomingIssuesLoading = false;
        state.upcomingIssues = action.payload || [];
      })
      .addCase(fetchUpcomingOverdueIssue.rejected, (state, action) => {
        state.upcomingIssuesLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchRequestTypeData.pending, (state) => {
        state.requestTypeLoading = true;
      })
      .addCase(fetchRequestTypeData.fulfilled, (state, action) => {
        state.requestTypeLoading = false;
        state.requestTypeData = action.payload;
      })
      .addCase(fetchRequestTypeData.rejected, (state, action) => {
        state.requestTypeLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchResolvedRequest.pending, (state) => {
        state.resolvedRequestLoading = true;
      })
      .addCase(fetchResolvedRequest.fulfilled, (state, action) => {
        state.resolvedRequestLoading = false;
        state.resolvedRequestData = action.payload;
      })
      .addCase(fetchResolvedRequest.rejected, (state, action) => {
        state.resolvedRequestLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchSlaMetrics.pending, (state) => {
        state.slaMetricsLoading = true;
      })
      .addCase(fetchSlaMetrics.fulfilled, (state, action) => {
        state.slaMetricsLoading = false;
        state.slaMetricsData = action.payload;
      })
      .addCase(fetchSlaMetrics.rejected, (state, action) => {
        state.slaMetricsLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchIssueTypeCount.pending, (state) => {
        state.issueTypeCountLoading = true;
      })
      .addCase(fetchIssueTypeCount.fulfilled, (state, action) => {
        state.issueTypeCountLoading = false;
        state.issueTypeCountData = action.payload;
      })
      .addCase(fetchIssueTypeCount.rejected, (state, action) => {
        state.issueTypeCountLoading = false;
        state.error = action.error.message;
      })
      .addCase(fetchBurnDown.pending, (state) => {
        state.burnDownLoading = true;
      })
      .addCase(fetchBurnDown.fulfilled, (state, action) => {
        state.burnDownLoading = false;
        state.burnDownData = action.payload;
      })
      .addCase(fetchBurnDown.rejected, (state, action) => {
        state.burndownLoading = false;
        state.error = action.error.message;
      })
  },
});

export default dashboardSlice.reducer;
